<template>
  <div class="page">
    <Header
      :setting="{
        title: '網路預約',
        hasCancelMethod: false,
      }"

      class="mb4"
    />
    <div
      @click="$router.push({path: '/appointment/doctor'})"
      class="bc--secondary border-radius-hot-dog pv3 mb4"
    >
      <div class="column--central">
        <div class=" fc--primary mv2">
          預約掛號
        </div>
      </div>
    </div>
    <div
      @click="$router.push({path: '/appointment/schedule'})"
      class="bc--secondary border-radius-hot-dog pv3 mb4"
    >
      <div class="column--central">
        <div class=" fc--primary mv2">
          門診總表
        </div>
      </div>
    </div>
    <div
      @click="$router.push({path: '/appointment/mothering-class'})"
      class="bc--secondary border-radius-hot-dog pv3 mb4"
    >
      <div class="column--central">
        <div class=" fc--primary mv2">
          媽媽教室預約
        </div>
      </div>
    </div>
  </div>
</template>
